/* eslint-disable import/no-default-export */
export default {
  Login: 'Entra',
  Logout: 'Esci',
  Ok: 'Ok',
  Save: 'Salva',
  Delete: 'Elimina',
  Edit: 'Modifica',
  Back: 'Indietro',
  Continue: 'Continua',
  Search: 'Cerca',
  Cancel: 'Annulla',
  Add: 'Aggiungi',
  Note: 'Note',
  Select: 'Seleziona'
}
